import * as React from 'react';

import UserApi from '../modules/users/api/UserApi';
import { Form, Header, Button, Input, Breadcrumb } from 'semantic-ui-react';
import {Link} from 'react-router-dom';
import {RouteComponentProps} from 'react-router';
import SearchQueryParser from '../../foundation/parsers/SearchQueryParser';
import Page from './Page';

interface Props {}

interface State {
	emailAddress: string;
	password: string;
	loading: boolean;
	error?: string;
}

export default class SignInPage extends Page<RouteComponentProps<Props>, State> {

	public constructor (props: RouteComponentProps<Props>) {
		super(props);

		this.state = {
			emailAddress: '',
			password: '',
			loading: true
		};
	}

	async componentWillMount () {
		const query = SearchQueryParser.execute(this.props.location.search);

		if (query.token === undefined) {
			this.setState({loading: false});

		} else {
			try {
				await UserApi.getInstance().signInWithSingleSignInToken(query.token);
				Page.navigate('/' + String(query.intent));

			} catch (e) {
				this.setState({loading: false});
			}
		}
	}

	protected isLoading () {
		return this.state.loading;
	}

	protected renderTitle () {
		return 'Sign in - Brain Brooder';
	}

	protected renderDescription () {
		return 'Sign in to Brain Brooder and learn about fundamental science from the bottom up, using small lessons and exercises.';
	}

	protected getPageName () {
		return 'SignIn';
	}

	protected renderContent () {
		const sections = [{ key: 'Home', content: <Link to={'/'}>Home</Link> }, { key: 'Sign in', content: 'Sign in', active: true }];

		return (
			<div className={'lesson'}>
				<Breadcrumb icon='right angle' sections={sections} />

				<Header dividing as='h1' inverted>Sign in</Header>

				<Form inverted onSubmit={this.signIn} style={{textAlign: 'center'}}>

					{/*{this.state.error ? <p className='ui error message'>{this.state.error}</p> : null}*/}

					<Form.Field>
						<label>Email address</label>
						<Input autoFocus={true} transparent type='text' autoComplete='off' placeholder='Email address' value={this.state.emailAddress} onChange={(event: any) => this.setState({emailAddress: event.target.value})}/>
					</Form.Field>

					<Form.Field>
						<label>Password</label>
						<Input transparent type='password' placeholder='Password' value={this.state.password} onChange={(event: any) => this.setState({password: event.target.value})}/>
					</Form.Field>

					<div style={{display: 'block', margin: '-12px 0 24px 0px', fontSize: '0.9em'}}>
						<Link to='/reset-password'>I forgot my password</Link>
					</div>

					<Button inverted type='submit'>Sign in</Button>
				</Form>
			</div>
		);
	}

	private signIn = async (event: Event) => {
		event.preventDefault();

		await UserApi.getInstance().signIn(this.state.emailAddress, this.state.password);

		Page.navigate('/');
	}
}


// WEBPACK FOOTER //
// ./code/project/pages/SignInPage.tsx